import {createSelector} from 'reselect';
import _ from 'lodash';
import {MINIMAL_PAYOUT_THRESHOLD} from '../../services/constants';

export const statsBranch = state => state.stats;

export const getStatsPool = createSelector(
  statsBranch,
  branch => branch.statsPool
);

export const getStatsUser = createSelector(
  statsBranch,
  branch => branch.statsUser
);

export const getEarningsSelector = createSelector(
  statsBranch,
  stats => stats.earnings,
);

export const getPoolHashrate = createSelector(getStatsPool, ({ results }) => {
  const current = results[0] ? results[0].hashrate : 0;
  const dayAverage = _.meanBy(results.slice(0, 24), 'hashrate');
  return { current, dayAverage };
});

export const getPoolHashrateChartData = createSelector(
  getStatsPool,
  ({ results }) => {
    return results.slice(0, 168).map(stats => ({
      timestamp: stats.timestamp,
      hashrate: stats.hashrate,
    })).reverse();
  }
);

export const getUserHashrate = createSelector(getStatsUser, ({ results }) => {
  const current = results[0] ? results[0].hashrate : 0;
  const dayAverage = _.meanBy(results.slice(0, 24), 'hashrate');
  return { current, dayAverage };
});

export const getUserHashrateChartData = createSelector(
  getStatsUser,
  ({ results }) => {
    return results.slice(0, 168).map(stats => ({
      timestamp: stats.timestamp,
      hashrate: stats.hashrate,
    })).reverse();
  }
);

export const isLoadingStatsPool = createSelector(
  getStatsPool,
  pool => pool.loading
);

export const isLoadingStatsUser = createSelector(
  getStatsUser,
  user => user.loading
);

export const isLoadingEarnings = createSelector(
  getEarningsSelector,
  earnings => earnings.loading
);

export const earningsResults = createSelector(
  getEarningsSelector,
  earnings => earnings.results
);

export const isPendingBelowThreshold = createSelector(
  earningsResults,
  results => {
    const pendingValue = _.get(results, 'pending', 0);
    return pendingValue > 0 && pendingValue < MINIMAL_PAYOUT_THRESHOLD;
  }
);

export const getStatsLanding = createSelector(
  statsBranch,
  branch => branch.statsLanding
);

export const getRealtimePoolHashrate = createSelector(
  getStatsLanding,
  statsLanding => statsLanding.realtime_pool_hashrate
);

export const getActiveWorkersCount = createSelector(
  getStatsLanding,
  statsLanding => statsLanding.active_workers_count
);



// WEBPACK FOOTER //
// /src/redux/selectors/stats.js